import React, { useState } from 'react';
import { Input, Checkbox, Radio, Segment, Button } from '../../components/ui';
import { useRouter } from 'next/router';
import Textarea from '../ui/Textarea';
import classNames from 'classnames';
import axios from 'axios';

const SeoPlanRequestForm = props => {
  const { className } = props;

  const router = useRouter();
  const { site } = router.query;

  const [values, setValues] = useState({
    companyName: '',
    companyWebsite: site || '',
    seoOutcomes: [],
    budget: '',
    projectDetails: '',
    name: '',
    email: '',
    phone: '',
    nda: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!values.companyName) newErrors.companyName = 'Company Name is required';
    if (!values.companyWebsite) newErrors.companyWebsite = 'Company Website is required';
    if (!values.name) newErrors.name = 'Your Name is required';
    if (!values.email) newErrors.email = 'Email is required';
    else if (!emailValidation(values.email)) newErrors.email = 'Email is not valid';
    else if (!isEmailBusiness(values.email)) newErrors.email = 'Please enter your Business Email';
    if (!values.phone) newErrors.phone = 'Phone Number is required';

    return newErrors;
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setLoading(false);
    setErrors({ ...errors, [name]: '' });

    setValues({
      ...values,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSeoOutcomeChange = value => {
    setValues({ ...values, seoOutcomes: value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);

    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const formData = new FormData(e.target);

    for (let key in values) {
      if (key === 'nda') {
        formData.append(key, values[key] ? 'Yes' : 'No');
      } else {
        formData.append(key, values[key]);
      }
    }
    formData.append('service', 'Seo service requst from');
    formData.append('country', props.country);
    axios.post('https://mailer.weprodigi.com/api/v1/seo-form', formData).then(response => {
      window.location.href = 'https://weprodigi.com/thank-you';
    });
  };

  const emailValidation = email => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!email || regex.test(email) === false) {
      return false;
    }
    return true;
  };

  const isEmailBusiness = email => {
    const publicDomains = [
      'gmail.com',
      'yahoo.com',
      'outlook.com',
      'hotmail.com',
      'aol.com',
      'icloud.com',
      'mail.com',
      'mail.ru',
      'zoho.com',
      'yandex.com',
      'yandex.ru',
      'protonmail.com',
    ];

    const domain = email?.split('@')[1];

    if (publicDomains.includes(domain)) {
      return false;
    }
    return true;
  };

  return (
    <form onSubmit={handleSubmit} className={classNames('flex flex-col gap-[24px]', className)}>
      <div className="flex lg:flex-row flex-col gap-[24px]">
        <div className="w-full lg:w-1/2">
          <Input label="Company Name *" name="companyName" value={values.companyName} error={errors.companyName} onChange={handleChange} />
        </div>
        <div className="w-full lg:w-1/2">
          <Input
            label="Company Website *"
            name="companyWebsite"
            value={values.companyWebsite}
            error={errors.companyWebsite}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="flex flex-col gap-[24px]">
        <p className="text-[18px] font-[500] leading-[20px]">What business outcomes would you like to achieve with our SEO services?</p>
        <div>
          <Segment
            options={[
              { label: 'Get More Website Visitors', value: 'Get More Website Visitors' },
              { label: 'Get More Leads', value: 'Get More Leads' },
              { label: 'Rank Higher on Google & Other Search Engine', value: 'Rank Higher on Google & Other Search Engine' },
              { label: 'Improve Website Content', value: 'Improve Website Content' },
              { label: 'Get Found by Local Customers', value: 'Get Found by Local Customers' },
              { label: 'Launch Into New Countries', value: 'Launch Into New Countries' },
            ]}
            selectedOptions={values.seoOutcomes}
            onChange={handleSeoOutcomeChange}
            className="purple_segment"
          />
        </div>
      </div>

      <div className="flex flex-col gap-[24px]">
        <p className="text-[18px] font-[500] leading-[20px]"> What business outcomes would you like to achieve with our SEO services?</p>
        <Radio
          name="budget"
          options={[
            { label: '$1,500 - $3,000', value: '1500-3000' },
            { label: '$3,000 - $5,000', value: '3000-5000' },
            { label: '$5,000 - $10,000', value: '5000-10000' },
            { label: '$10,000+', value: '10000+' },
          ]}
          selectedOption={values.budget}
          onChange={handleChange}
        />
      </div>

      <div className="flex flex-col gap-[24px]">
        <p className="text-[18px] font-[500] leading-[20px]">Is there anything specific we should know about your project?</p>
        <Textarea
          name="projectDetails"
          id="projectDetails"
          placeholder="Background, requirements, deadline, etc."
          value={values.projectDetails}
          onChange={handleChange}
        />
      </div>

      <div className="flex lg:flex-row flex-col gap-[24px]">
        <div className="w-full lg:w-1/2">
          <Input label="Your Name *" name="name" value={values.name} error={errors.name} onChange={handleChange} />
        </div>
        <div className="w-full lg:w-1/2">
          <Input label="Your Business Email *" name="email" type="email" value={values.email} error={errors.email} onChange={handleChange} />
        </div>
      </div>

      <div className="flex lg:flex-row flex-col gap-[24px]">
        <div className="w-full lg:w-1/2 ">
          <Input label="Your Phone Number *" name="phone" value={values.phone} error={errors.phone} onChange={handleChange} />
        </div>
        <div className="w-full md:w-1/2 px-3 flex flex-col gap-[10px]">
          <p className="text-[18px] font-[500] leading-[20px]">Is an NDA necessary?</p>
          <Checkbox name="nda" label="Yes" checked={values.nda} error={errors.nda} onChange={handleChange} />
        </div>
      </div>

      <div className="flex items-center justify-center w-full">
        <a href={`/seo/seo-form`} className="w-full">
          <Button variant="primary" narrowing="both" mode="light" className="w-full">
            {loading && (
              <svg className="pl" viewBox="0 0 200 200" width="200" height="200" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <linearGradient id="pl-grad1" x1="1" y1="0.5" x2="0" y2="0.5">
                    <stop offset="0%" stopColor="hsl(313,90%,55%)" />
                    <stop offset="100%" stopColor="hsl(223,90%,55%)" />
                  </linearGradient>
                  <linearGradient id="pl-grad2" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="hsl(313,90%,55%)" />
                    <stop offset="100%" stopColor="hsl(223,90%,55%)" />
                  </linearGradient>
                </defs>
                <circle
                  className="pl__ring"
                  cx="100"
                  cy="100"
                  r="82"
                  fill="none"
                  stroke="url(#pl-grad1)"
                  strokeWidth="36"
                  strokeDasharray="0 257 1 257"
                  strokeDashoffset="0.01"
                  strokeLinecap="round"
                  transform="rotate(-90,100,100)"
                />
                <line
                  className="pl__ball"
                  stroke="url(#pl-grad2)"
                  x1="100"
                  y1="18"
                  x2="100.01"
                  y2="182"
                  strokeWidth="36"
                  strokeDasharray="1 165"
                  strokeLinecap="round"
                />
              </svg>
            )}
            Get your free SEO plan
          </Button>
        </a>
      </div>
    </form>
  );
};

export default SeoPlanRequestForm;
